const TheContainer = () => import('@/containers/TheContainer')

export default [
    {
        path: '/contract-manager/:contractManagerId/collaborators',
        component: TheContainer,
        meta: {
            breadcrumb: (context) => {
                const cm = context.store.getters['contractManager/contract_manager']
                const contractManagerId = context.route.params.contractManagerId

                if (!cm || cm.id !== parseInt(contractManagerId)) {
                    context.store.dispatch('contractManager/fetchContractManager', contractManagerId)
                        .catch(() => {})
                }

                return [
                    { to: { name: 'index' }, text: context.gettext('Dashboard') },
                    { to: { name: 'contract_manager.list' }, text: 'Contract Managers' },
                    {
                        to: { name: 'contract_manager.detail', params: { id: contractManagerId } },
                        text: cm && cm.id === parseInt(contractManagerId) ? cm.name : `Contract Manager #${contractManagerId}`
                    }
                ]
            },
            breadcrumbMode: 'replace'
        },
        children: [
            {
                path: '',
                name: 'contractManager.collaborators',
                component: () => import('./index.vue'),
                meta: {
                    label: 'Collaborators',
                    scopeType: 'contract-manager',
                    permission: 'contract_manager.collaborator.list'
                }
            }
        ]
    },
    {
        path: '/admin/collaborators',
        component: TheContainer,
        children: [
            {
                path: '',
                name: 'admin.collaborators',
                component: () => import('./index.vue'),
                meta: {
                    scopeType: 'global',
                    permission: 'admin.collaborator.list'
                }
            }
        ]
    }
];